import * as React from 'react';
import CompareScriptLine from '../CompareScriptLine/CompareScriptLine';
import ProjectLeftPanel from '../../../components/ProjectLeftPanel/ProjectLeftPanel';
import ProjectLeftPanelTitle from '../../../components/ProjectLeftPanel/ProjectLeftPanelTitle';
import ProjectLeftPanelList from '../../../components/ProjectLeftPanel/ProjectLeftPanelList';
import ProjectLeftPanelListItem from '../../../components/ProjectLeftPanel/ProjectLeftPanelListItem';
import { useCallback } from 'react';
import { ICompredScript } from '../../../../models/ICompredScript';

type CompareScriptsPanel = {
    scripts: ICompredScript[],
    isLoading: boolean,
    selectedScript: ICompredScript
    changeSelectedScript: (script: ICompredScript) => void
}

function CompareScriptsPanel({
    scripts,
    isLoading,
    selectedScript,
    changeSelectedScript
}) {
    const goToScriptCb = useCallback((script) => {
        changeSelectedScript({ script });
    }, []);

    const onlyScripts = scripts?.filter(s => s.type !== 'transform');
    const onlyTransforms = scripts?.filter(s => s.type === 'transform');

    return (
        <div className="compare-scripts-panel">
            <ProjectLeftPanel hasData={!isLoading}>
                <ProjectLeftPanelTitle title="Scripts" />
                <ProjectLeftPanelList>
                    {onlyScripts.map(script => {
                        return <ProjectLeftPanelListItem
                            key={script.scriptId}
                            selected={selectedScript.name === script.name}>
                            <CompareScriptLine
                                script={script}
                                scriptName={selectedScript.name}
                                goToScript={goToScriptCb}
                            />
                        </ProjectLeftPanelListItem>;
                    })}
                </ProjectLeftPanelList>
                <ProjectLeftPanelTitle title="Transforms" />
                <ProjectLeftPanelList>
                    {onlyTransforms.map(script => {
                        return <ProjectLeftPanelListItem
                            key={script.scriptId}
                            selected={selectedScript.name === script.name}>
                            <CompareScriptLine
                                script={script}
                                scriptName={selectedScript.name}
                                goToScript={goToScriptCb}
                            />
                        </ProjectLeftPanelListItem>;
                    })}
                </ProjectLeftPanelList>
            </ProjectLeftPanel>
        </div>
    );
}

export default CompareScriptsPanel;
